import httpAjax from './../common/http.js'

let addressGetLists=[];


/**
 * 获取所有城市的请求
 * @returns {Promise}
 */
function addressGetHttp () {
  return new Promise((resolve, reject) => {
    try {
      httpAjax.getAjax('CityWebService.asmX/GetAllCity').then(function (data) {
        addressGetLists=data;
        resolve(data)
      }, function (err) {
        console.log(err)
      })
    } catch (err) {
      console.log(err)
    }
  })
}

function onlyCityData(data,id) {
  let len=(data?data.length||'':''),newData='';
  if(len){
    for(var i=0;i<data.length;i++){
      if(data[i].cityId==id){
        data[i]['index']=i;
        newData=data[i];
        break;
      }else {
        let cityData=data[i].child,cityLen=(cityData?cityData.length||'':'');
        if(cityLen){
          for(var j=0;j<cityLen;j++){
            if(cityData[j].cityId==id){
              cityData[j]['index']=j;
              cityData[j]['i']=i;
              cityData[j]['data']=cityData;
              newData=cityData[j];
              break;
            }
          }
        }
      }
    }
    return newData;
  }
}


function onlyTypeData(data,id) {
  let len=(data?data.length||'':''),newData='';
  if(len){
    for(var i=0;i<data.length;i++){
      if(data[i].id==id){
        data[i]['index']=i;
        newData=data[i];
        break;
      }
    }
    return newData;
  }
}

/**
 * 获取职业的数据
 * @returns {Promise}
 */
function navGetHttp () {
  return new Promise((resolve, reject) => {
    try {
      httpAjax.getAjax('PanoWebService.asmx/GetPanoType').then(function (data) {
        resolve(data)
      }, function (err) {
        console.log(err)
      })
    } catch (err) {
      console.log(err)
    }
  })
}
/*function panMousewheel (callBack) {
  $(document).on('click', '.iframe-pan', function () {
    var that = $(this);
    that.addClass('iframe-active');
    callBack(0)
    setTimeout(function () {
      that.removeClass('iframe-active');
      callBack(1)
    }, 4000);
  })
}*/


function panMousewheel (callBack) {
  $(document).on('click', '.iframe-pan', function () {
    var that = $(this);
    that.addClass('iframe-active');
    callBack(1);
    setTimeout(function () {
      that.removeClass('iframe-active');
      callBack(0)
    }, 6000);
  })
  /*$(document).off('click', '.iframe-pan');
  $(document).on('click', '.iframe-pan', function () {
    var that = $(this);
    that.addClass('iframe-active');
    callBack(1);
  })*/


/*  if(IsPC()){
    let that='';
    $(document).find('.iframe-pan').hover(function () {
      that=$(this);
      setTimeout(function () {
        that.addClass('iframe-active');
        callBack(1)
      },1500)
    },function () {
      callBack(0);
      that.removeClass('iframe-active');
      that='';
    })
  }else {

  }*/

}

function addressGetData (callback) {
  if(!(addressGetLists&&addressGetLists.length)){
    addressGetHttp().then(function (data) {
      callback(data)
    }, function (err) {
      console.log(err)
    })
  }else {
    callback(addressGetLists)
  }

}
function navGetdata (callback) {
  navGetHttp().then(function (data) {
    callback(data)
  }, function (err) {
    console.log(err)
  })
}

/**
 * 拼音排序并按字母分类
 * @param arr
 * @param empty
 * @returns {*}
 */
function pySegSort (arr, empty) {
  if (!String.prototype.localeCompare) {
    return null
  }

  let letters = '*abcdefghjklmnopqrstwxyz'.split('')
  let zh = '阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀'.split('')

  let segs = []
  let curr
  $.each(letters, function (i) {
    curr = {letter: this, data: []}
    $.each(arr, function (index) {
      let that = this
      let name = that.name
      if (name && ((!zh[i - 1] || zh[i - 1].localeCompare(name, 'zh') <= 0) && name.localeCompare(zh[i], 'zh') === -1)) {
        that.i = index
        curr.data.push(this)
      }
    })
    if (empty || curr.data.length) {
      segs.push(curr)
      curr.data.sort(function (a, b) {
        return (a.name).localeCompare(b.name, 'zh')
      })
    }
  })
  return segs
}

/**
 * 模糊查询数组
 * @param arr
 * @param str
 */
function fuzzyQuery (arr, str) {
  // 新的列表
  let newList = []
  for (var i = 0; i < arr.length; i++) {
    let name = arr[i].name
    if (arr[i].child && arr[i].child.length) {
      for (let j = 0; j < arr[i].child.length; j++) {
        let nameChild = arr[i].child[j].name
        if (nameChild.indexOf(str) >= 0) {
          arr[i].child[j].cityIndex = i
          arr[i].child[j].countyIndex = j
          newList.push(arr[i].child[j])
        }
      }
    }
    if (name.indexOf(str) >= 0) {
      arr[i].cityIndex = i
      arr[i].countyIndex = -1
      newList.push(arr[i])
    }
  }

  return newList
}

/**
 * 重新分为二维数组
 * @param ArrayList
 * @param n
 * @returns {Array}
 */
/**
 *
 * @param ArrayList
 * @param n
 * @param isState
 * @returns {*}
 */
function newList (ArrayList, n,isState) {
  let arrList=JSON.parse(JSON.stringify(ArrayList))
  let len=(ArrayList&&ArrayList.length?ArrayList.length:0)
  if (len && n > 0) {
    let newArray = [];
    let num = Math.ceil(len / n);
    for (let i = 0; i < num; i++) {
      newArray.push(ArrayList.splice(0, n))
    }

    if(isState){
      let n=0;
      for (let k = 0; k < len; k++) {
        if(arrList[k].state){
          n++
        }
      }
      return {
        stateNum:n,
        data:newArray
      }
    }else {
      return newArray
    }

  }
}

/**
 * 生成二维码
 */
/* eslint-disable */
function qrCode (target,bool,parentClass) {
  // eslint-disable-next-line
  htmlQrCode(target, bool, {
    content: '', // 内容，可为utl,如html://www.baidu.com 或文字，图片信息之类的
    logo: 'public/images/topLogo.jpg', // 二维码中间显示图片，   如:html://wwww.xxx.com/imgname.jpg
    bgColor: 'ffffff', // 背景颜色，             格式 ：颜色代码            如fffaf0
    fgColor: '000000', // 前景颜色，即条纹颜色     格式 ：同上
    gcColor: '', // 渐变颜色,              格式 : 同上
    ptColor: '', // 定位点颜色(外框)        格式：同上
    inptColor: '', // 定位点颜色(内点)        格式：同上
    eLevel: '', // 纠错等级, 可用值:h\q\m\l  格式 : 单个字符         如 h
    w: '800', // 宽度尺寸               格式：像素值              如  200
    m: '10'// 外边距尺寸               格式：如上
  })
}

const UrlEncode = {
  encode (str) { // 参数加密
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes (match, p1) {
        return String.fromCharCode('0x' + p1)
      }))
  },
  decode (str) { // 参数解密
    if (str && str.key) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str.key).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
    } else {
      return '{}'
    }
  }
}

function decode(query) {
  let parameter = {
    cityId: 0,
    cityIndex: -1,
    countyIndex: -1,
    topIndex: -1,
    typeId: 0
  };
  let currentParams = JSON.parse(UrlEncode.decode(query))
  parameter.cityId = currentParams.cityId || 0
  parameter.typeId = currentParams.typeId || 0
  parameter.cityIndex = currentParams.cityIndex>=0?currentParams.cityIndex: -1
  parameter.countyIndex = currentParams.countyIndex>=0?currentParams.countyIndex:-1
  parameter.topIndex = currentParams.topIndex>=0?currentParams.topIndex:-1
  return parameter
}

/**
 * 判断是否是pc
 * @returns {boolean}
 * @constructor
 */
function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}


/**
 * cookie
 * @param state
 * @returns {boolean}
 */
function isNewVisitor(state) {
// 从cookie读取“已经向访客提示过消息”的标志位
  var flg = getCookie(state);
  if (flg === "") {
    // 标记：已经向该访客弹出过消息。30天之内不要再弹
    setCookie(state, "true", 60);
    return true;
  } else {
    return false;
  }
}

/**
 * 写字段到cookie
 * @param cname
 * @param cvalue
 * @param exdays
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = ('gznotes-visited'+cname) + "=" + cvalue + "; " + expires + ";path=/";
}


/**
 * 读cookie
 * @param cname
 * @returns {*}
 */
function getCookie(cname) {
  var name = 'gznotes-visited'+cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

/**
 * setUrlCookie
 * @param cname
 * @param cvalue
 * @param exdays
 */
function setUrlCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = ('QR'+cname) + "=" + cvalue + "; " + expires + ";path=/";
}


/**
 * getUrlCookie
 * @param cname
 * @returns {*}
 */
function getUrlCookie(cname) {
  var name = 'QR'+cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

/**
 * 判断是否滚动到容器的底部
 * @param obj
 * @param per
 * @returns {boolean}
 */
function isScrollBottom(obj,per) {
  let b = per?per:0.98
  var viewH = $(obj).height(),//可见高度
    contentH = $(obj).get(0).scrollHeight,//内容高度
    scrollTop = $(obj).scrollTop();//滚动高度
  if (scrollTop / (contentH - viewH) >= b) { //到达底部100px时,加载新内容
    return true
  }else {
    return false
  }
}

/**
 * 执行记录历史数据
 * @param item 储存当前的数据
 * @param historyName  localStorage的getItem 和 setItem的数组名字，主要用来做不同界面调用各自的历史记录。
 */
function recordHist(item,historyName) {
  let menuHistory = initlocalStorage(historyName);
  if (item.id > 0) { //这里判断输入的value是否合法，也可以用自己的判断方式
    let Name = item.id + "@" + item.name;
    //输入的内容localStorage有记录
    if ($.inArray(Name, menuHistory) >= 0) {
      var keyval = Object.keys(menuHistory).filter(function (x) { return menuHistory[x] == Name }).toString();
      menuHistory.splice(Number(keyval), 1); //splice(index,1):index代表value值在数组中对应到下标，1：表示删除
    } else {
      if (menuHistory.length > 9) {
        menuHistory.pop();
      }
    }
    menuHistory.unshift(Name);
    localStorage.removeItem(historyName);
    localStorage.setItem(historyName, JSON.stringify(menuHistory)); // 因为localStorage的value不能直接放数组，所以转换程json串后，再set
  }

}

/**
 * 滚动到顶部
 */
function downToUp(n) {
  if(n==1){
    $('.app-content').animate({scrollTop: 0}, 500)
  }else {
    $('body').animate({scrollTop: 0}, 500)
  }
}

/**
 * 获取指定的localStorageobj对象，并转成Array对象。
 * @param historyName
 */
function initlocalStorage(historyName) {
  let localStorageobj = localStorage.getItem(historyName);
  if (localStorageobj) {
  } else {
    localStorage.setItem(historyName, "[]");
    localStorageobj = localStorage.getItem(historyName);
  }
  return JSON.parse(localStorageobj)
}

/**
 * 清除记录功能
 * @param historyName
 * @constructor
 */
function ClearnSerchHistry(historyName) {
  localStorage.setItem(historyName, JSON.stringify([]));
  initlocalStorage(historyName);
}

/**
 * 修改document标题
 * @param name
 * @param cityId
 */
function changeDocumentTitle(name,cityId) {
  console.log('cityId:'+cityId)
/*  let title = JSON.parse(JSON.stringify(name?name:(httpAjax.readNamePacId==50?'重庆':'四川')))
  let reg  = /(市|县|镇|区|州)$/g
  let replaceTitle = title.replace(reg,'')*/

  // document.title = '魅力'+replaceTitle

  httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: cityId||0}).then(function (res) {
    if (res.code === 1) {
      var data = res.data[0]||{};
      document.title = data.charmName?data.charmName:(httpAjax.readNamePacId==50?'魅力重庆':'魅力四川')
    }
  }, function (err) {
    console.log(err)
  });

}


export default {
  onlyCityData:onlyCityData,
  onlyTypeData:onlyTypeData,
  addressGetData: addressGetData,
  panMousewheel: panMousewheel,
  navGetData: navGetdata,
  encode: UrlEncode.encode,
  decode: UrlEncode.decode,
  decodeFun: decode,
  pySegSort: pySegSort,
  fuzzyQuery: fuzzyQuery,
  newList: newList,
  qrCode: qrCode,
  isNewVisitor: isNewVisitor,
  getCookie: getCookie,
  setCookie: setCookie,
  IsPC:IsPC,
  isScrollBottom:isScrollBottom,
  recordHist: recordHist,
  initlocalStorage: initlocalStorage,
  ClearnSerchHistry: ClearnSerchHistry,
  downToUp:downToUp,
  changeDocumentTitle: changeDocumentTitle,
  setUrlCookie:setUrlCookie,
  getUrlCookie:getUrlCookie
}





// WEBPACK FOOTER //
// ./src/common/public.js